import styled from "styled-components";
import { device } from "../../../../../utils/device";

export const PrgsGraph = styled.div`
  border: 1px solid #3731574d;
  border-radius: 8px;
  overflow:hidden;
  border-radius: 8px;
  padding-bottom: 20px;
  .recharts-responsive-container{
    position:relative;
  }
  .recharts-responsive-container::before{
    position: absolute;
    content: '';
    top: 20px;
    left: 80px;
    width: calc(100% - 110px);
    height: 122px;
    background-color: #FFFDF4;
  }
  .recharts-cartesian-grid-horizontal line:nth-child(10), line:nth-child(8){
    opacity:0;
  }
  .yAxis .recharts-cartesian-axis-ticks .recharts-layer:nth-child(10) text, .recharts-layer:nth-child(8) text {
    opacity:0;
  }
  .recharts-cartesian-grid-horizontal line:nth-child(5), line:nth-child(6), line:nth-child(11){
    stroke:#554276;
  }
  .yAxis .recharts-cartesian-axis-ticks .recharts-layer text{
    font-size:9px;
  }
  .yAxis .recharts-cartesian-axis-ticks .recharts-layer:nth-child(6) text, .recharts-layer:nth-child(11) text{
    font-size:12px;
    font-weight:900;
  }
  .yAxis .recharts-cartesian-axis-ticks .recharts-layer:nth-child(5) text {
    font-weight:900;
  }
  .xAxis .recharts-cartesian-axis-ticks .recharts-layer text {
    font-size:12px;
  }
  .recharts-layer .recharts-label-list text {
    font-weight: 700;
    font-size: 9px;
    line-height: 12px;
  }

  @media ${device.mobileS} {
    .recharts-wrapper{
      margin-left: -20px;
    }
    .recharts-responsive-container::before{
      position: absolute;
      content: '';
      top: 20px;
      left: 40px;
      width: calc(100% - 76px);
      height: 122px;
      background-color: #FFFDF4;
    }
  }
`;
export const PrgsLegends = styled.ul`
  display: flex;
  justify-content: flex-end;
  padding-right: 28px;
  li{
    font-size: 10px;
    color: #4A4A4A;
    display: inline-flex;
    align-items: center;
    margin-left: 23px;
    &::before{
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 1px;
      margin-right: 4px;
      flex-shrink: 0;
    }
    &:nth-child(1)::before{
      background-color: #8D7DB0;
    }
    &:nth-child(2)::before{
      background-color: #8D7DB0;
      opacity: 0.5;
    }
    &:nth-child(3)::before{
      background-color: #FFF9DD;
    }
    &:nth-child(4)::before{
      background-color: #504171;
    }
  }
  @media ${device.mobileS} {
    
  }
`;
export const PrgsJourneyCta = styled.button`
  background-color: #fff;
  border: 1px #0091FF solid;
  border-radius: 4px;
  cursor: pointer;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Lato';
  color: #008CFF;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: 34px;
  align-items: center;
  justify-content: center;
  padding: 13px 16px;
`;

export const CustomTooltip = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);
  padding: 20px;
  border-radius:12px;

  .bulletBoxTC {
    display:inline-block;
    background: #8D7DB0;
    border-radius: 1px;
    height:8px;
    width:8px;
    margin-right:6px;
    align-self:flex-start;
    margin-top:4px;
  }

  .bulletBoxHTC {
    display:inline-block;
    background: #504171;
    border-radius: 1px;
    height:8px;
    width:8px;
    margin-right:6px;
    align-self:flex-start;
    margin-top:4px;
  }

  .bulletBoxY2T {
    display:inline-block;
    background: #8D7DB0;
    opacity:0.5;
    border-radius: 1px;
    height:8px;
    width:8px;
    margin-right:6px;
    align-self:flex-start;
    margin-top:4px;
  }

  .label {
    font-weight:700;
    font-size:11px;
    line-height:13px;
    color:black;
    margin-bottom:1px;
  }
`;

export const TooltipIcon = styled.img`
  height:20px;
  width:20px;
  margin-right:3px;
`;


export const Divider = styled.p`
    opacity: 0.3;
    border-bottom: 1px dashed #4A4A4A;
    margin:20px 0px;
`;